import {USER_MANGEMENT_ROLES} from 'src/constants';

export const OPTIONS = [{id: '', label: '', disabled: true}, ...USER_MANGEMENT_ROLES.map((o) => ({...o, disabled: false}))];

export const REQUIRED_CREATE_FIELDS = ['username', 'lastName', 'firstName', 'password', 'confirmPassword'] as const;
export const REQUIRED_EDIT_FIELDS = ['username', 'lastName', 'firstName'] as const;
